import React,{useState,useRef,useEffect,useMemo} from "react";
import axios from "../../plugins/axios";
import moment from "moment";
import { useRecoilState } from 'recoil'
import { useTranslation } from "react-i18next";
import { selectBedInfoState, isFromSearchState } from '../../plugins/recoil'

import { ReactComponent as IconArrowDown } from "../../assets/icons/ic-arrow-down.svg";
import Filter from "./Arrhythmia/filter"; 

// 기존 코드 매핑
// const dbCodeMappings = {
//     "Asystole": "Asystole",
//     "V-FIB": "V-FIB", 
//     "Ventricular Tachycardia": "V-TACH",
//     "Ventricular Rhythm": "V-Rhythm",
//     "Tachycardia": "Tachycardia",
//     "Bradycardia": "Bradycardia",
//     "Run PVCS": "Run PVCs",
//     "Ventricular Trigeminy": "Trigeminy",
//     "Ventricular Bigeminy": "Bigeminy",
//     "Pause": "Missed/Pause",
//     "Pair PVCS": "Couplet/pair",
//     "PVCS": "Frequent",
//     "R ON T PVCS": "R on T",
//     "Multiform PVCS": "Multiform",
//     "Paced Beat": "Paced beat",
//     "Unknown": "Unknown",
//     "Cannot Analyze ECG": "Cannot Analyze",
//     "SVPBs": "SVPBs",
//     "AFib/AFlutter": "Afib/AFlutter"
// };

const dbCodeMappings = {
    "asystole": "Asystole",
    "vfib": "V-FIB",
    "vtach": "V-TACH",
    "vrythm": "V-Rhythm",
    "tachycardia": "Tachycardia",
    "bradycardia": "Bradycardia",
    "runpvcs": "Run PVCs",
    "trigeminy": "Trigeminy",
    "bigeminy": "Bigeminy",
    "missedpause": "Missed/Pause",
    "coupletpair": "Couplet/pair",
    "frequent": "Frequent",
    "ront": "R on T",
    "multiform": "Multiform",
    "pacedbeat": "Paced beat",
    "unknown": "Unknown",
    "cannotanalyze": "Cannot Analyze",
    "svpbs": "SVPBs",
    "afibaflutter": "Afib/AFlutter"
};

const filterDefaultCodeList = [
    "Asystole", "V-FIB", "V-TACH", "V-Rhythm", "Tachycardia", "Bradycardia", "Run PVCs",
    "Trigeminy", "Bigeminy", "Missed/Pause", "Couplet/pair", "Frequent", "R on T", "Multiform",
    "Paced beat", "Unknown", "Cannot Analyze", "SVPBs", "Afib/AFlutter"
];

const Arrhythmia = ({patientHistories, patientLatestHistory, isTrendFull, onClose, selectBoxTimeInfo, waveStartDate, waveEndDate,trendZoom }) => {
    const { t } = useTranslation()
    const [selectBedInfo,] = useRecoilState(selectBedInfoState)
    const [isFromSearch, ] = useRecoilState(isFromSearchState)
    const [arrhythmiaEvents, setArrhythmiaEvents] = useState([]);
    const [isOpenFilter, setIsOpenFilter] = useState(false)
    const [codeFilter, setCodeFilter] = useState([])
    const [dashLineLeftPercent, setDashLineLeftPercent] = useState(null); // 점선 위치 상태 추가    
    const [codeCountArr, setCodeCountArr] = useState([]);
    const [stripedBackground, setStripedBackground] = useState(); // 빗금 배경
    const [patientLines, setPatientLines] = useState(); // 빗금 위치 상태 추가
    
    //빗금 만들기 위함
    const getPatientHistories = (histories) => {
        if (!histories || !Array.isArray(histories) || histories.length === 0) {
            setStripedBackground([]);
            setPatientLines([]);
            return;
        }

        const startTime = moment(waveStartDate);
        const endTime = moment(waveEndDate);

        // waveStartDate ~ waveEndDate 범위에 포함되는 데이터만 필터링
        const unassignedList = histories            
            .filter(h => {
                const t = moment(h.createdAt);
                return t.isValid() && t.isSameOrAfter(startTime) && t.isSameOrBefore(endTime);
            })
            .sort((a, b) => moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf());

        // selectBoxTimeInfo 시간
        const selectBoxTime = moment(selectBoxTimeInfo);
        const totalDuration = endTime.diff(startTime); // 전체 구간 ms

        // 환자별로 그룹화
        const patientGroups = {};
        unassignedList.forEach(history => {
            if (!patientGroups[history.patientId]) {
                patientGroups[history.patientId] = [];
            }
            patientGroups[history.patientId].push(history);
        });

        // 빗금 영역과 선 위치 배열
        const stripedAreas = [];
        const linePositions = [];

        // Not Admitted 구간 정의
        const notAdmittedSegments = [];

        // 환자가 없는 경우 전체 구간을 Not Admitted로 설정
        if (Object.keys(patientGroups).length === 0) {
            notAdmittedSegments.push({
                start: startTime.clone(),
                end: endTime.clone(),
                shouldDrawLine: false,
                type: 'NO_PATIENT_DATA'
            });
        }

        // 각 환자별로 Not Admitted 구간 찾기
        Object.keys(patientGroups).forEach(patientId => {
            const patientHistories = patientGroups[patientId].sort((a, b) => 
                moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()
            );

            // 각 환자별로 순차적으로 구간 생성 (중복 방지)
            let currentTime = startTime.clone();

            for (let i = 0; i < patientHistories.length; i++) {
                const current = patientHistories[i];
                const currentEventTime = moment(current.createdAt);

                // 현재 시간부터 현재 이벤트까지의 구간 (Not Admitted)
                if (currentTime.isBefore(currentEventTime)) {
                    notAdmittedSegments.push({
                        start: currentTime.clone(),
                        end: currentEventTime,
                        shouldDrawLine: true,
                        type: `${currentTime.isSame(startTime) ? 'START' : 'CONTINUING'}_TO_${current.action}`,
                        patientId: patientId
                    });
                }

                // 현재 이벤트 처리
                if (current.action === 'ADMITTED') {
                    // ADMITTED 이후 다음 이벤트까지 또는 endTime까지 (Not Admitted)
                    const next = patientHistories[i + 1];
                    const nextEventTime = next ? moment(next.createdAt) : endTime.clone();

                    notAdmittedSegments.push({
                        start: currentEventTime,
                        end: nextEventTime,
                        shouldDrawLine: next ? true : false, // 다음 이벤트가 있으면 선 표시, endTime까지면 선 없음
                        type: next ? `ADMITTED_TO_${next.action}` : 'ADMITTED_TO_END',
                        patientId: patientId
                    });

                    currentTime = nextEventTime;
                } else if (current.action === 'UNASSIGNED') {
                    // UNASSIGNED 이후 전체 히스토리에서 다음 ADMITTED 찾기
                    let nextAdmitted = null;
                    let nextAdmittedTime = null;
                    
                    // 전체 환자 히스토리에서 현재 UNASSIGNED 이후의 ADMITTED 찾기
                    const currentUnassignedTime = moment(current.createdAt);
                    
                    // 모든 환자의 히스토리를 시간순으로 정렬하여 검색
                    const allHistoriesAfterUnassigned = [];
                    Object.keys(patientGroups).forEach(pid => {
                        patientGroups[pid].forEach(history => {
                            const historyTime = moment(history.createdAt);
                            if (historyTime.isAfter(currentUnassignedTime)) {
                                allHistoriesAfterUnassigned.push(history);
                            }
                        });
                    });
                    
                    // 시간순으로 정렬
                    allHistoriesAfterUnassigned.sort((a, b) => 
                        moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()
                    );
                    
                    // 첫 번째 ADMITTED 찾기
                    for (let history of allHistoriesAfterUnassigned) {
                        if (history.action === 'ADMITTED') {
                            nextAdmitted = history;
                            nextAdmittedTime = moment(history.createdAt);
                            break;
                        }
                    }
                    
                    const nextEventTime = nextAdmittedTime || endTime.clone();

                    notAdmittedSegments.push({
                        start: currentEventTime,
                        end: nextEventTime,
                        shouldDrawLine: nextAdmitted ? true : false, // 다음 ADMITTED가 있으면 선 표시
                        type: nextAdmitted ? `UNASSIGNED_TO_ADMITTED` : 'UNASSIGNED_TO_END',
                        patientId: patientId
                    });

                    // currentTime을 다음 ADMITTED 시점으로 이동
                    currentTime = nextEventTime;
                    
                    // 다음 ADMITTED를 찾았으면 해당 시점 이후로 건너뛰기
                    if (nextAdmitted) {
                        // 현재 환자의 히스토리에서 다음 ADMITTED 시점 이후의 이벤트부터 계속 처리
                        while (i + 1 < patientHistories.length && 
                               moment(patientHistories[i + 1].createdAt).isSameOrBefore(nextAdmittedTime)) {
                            i++;
                        }
                    } else {
                        // ADMITTED가 없으면 루프 종료
                        break;
                    }
                }
            }

            // 마지막 이벤트 이후 endTime까지 구간이 남아있다면 추가
            if (currentTime.isBefore(endTime)) {
                notAdmittedSegments.push({
                    start: currentTime.clone(),
                    end: endTime.clone(),
                    shouldDrawLine: true,
                    type: 'FINAL_TO_END',
                    patientId: patientId
                });
            }
        });        

        // 각 Not Admitted 구간을 독립적으로 처리
        const allNotAdmittedRanges = []; // 모든 Not Admitted 범위를 저장
        
        notAdmittedSegments.forEach((segment, segmentIndex) => {
            // startTime과 endTime 범위 내의 구간만 처리
            const segmentStart = moment.max(segment.start, startTime);
            const segmentEnd = moment.min(segment.end, endTime);
            
            // 유효한 구간인지 확인
            if (segmentEnd.isAfter(segmentStart)) {
                const startPercent = (segmentStart.diff(startTime) / totalDuration) * 100;
                const endPercent = (segmentEnd.diff(startTime) / totalDuration) * 100;
                
                // unix를 사용한 정확한 시간 비교
                const selectBoxTimeUnix = selectBoxTime.unix();
                const segmentStartUnix = segmentStart.unix();
                const segmentEndUnix = segmentEnd.unix();
                
                const isSelectBoxInSegment = selectBoxTimeUnix >= segmentStartUnix && selectBoxTimeUnix <= segmentEndUnix;

                // console.log(`구간 ${segmentIndex + 1} (${segment.type}):`, {
                //     환자ID: segment.patientId,
                //     구간: `${segmentStart.format('HH:mm:ss')} ~ ${segmentEnd.format('HH:mm:ss')}`,
                //     selectBox위치: selectBoxTime.format('HH:mm:ss'),
                //     selectBox구간포함: isSelectBoxInSegment,
                //     빗금표시예정: !isSelectBoxInSegment,
                //     선표시예정: segment.shouldDrawLine && !isSelectBoxInSegment
                // });
                
                // selectBoxTime이 구간에 포함되지 않으면 Not Admitted 범위에 추가
                if (!isSelectBoxInSegment) {
                    allNotAdmittedRanges.push({
                        start: Math.max(0, startPercent),
                        end: Math.min(100, endPercent)
                    });
                }

                // 선 추가 (selectBox와 관계없이 독립적으로)
                if (!isSelectBoxInSegment && segment.shouldDrawLine && endPercent >= 0 && endPercent <= 100) {
                    if(startPercent > 0){
                        linePositions.push(startPercent);
                    }

                    if(endPercent < 100){
                        linePositions.push(endPercent);
                    }
                }
            }
        });

        // Not Admitted 범위들을 병합하여 중복 제거
        const mergedStripedAreas = mergeOverlappingRanges(allNotAdmittedRanges);

        // 중복 제거 및 정렬
        const uniqueLinePositions = [...new Set(linePositions)].sort((a, b) => a - b);

        // 빗금 영역과 선 설정
        setStripedBackground(mergedStripedAreas);
        setPatientLines(uniqueLinePositions);
    };

    // 겹치는 범위들을 병합하는 함수
    const mergeOverlappingRanges = (ranges) => {
        if (ranges.length === 0) return [];
        
        // start 기준으로 정렬
        const sortedRanges = ranges.sort((a, b) => a.start - b.start);
        const merged = [sortedRanges[0]];
        
        for (let i = 1; i < sortedRanges.length; i++) {
            const current = sortedRanges[i];
            const lastMerged = merged[merged.length - 1];
            
            // 겹치거나 인접한 경우 병합
            if (current.start <= lastMerged.end) {
                lastMerged.end = Math.max(lastMerged.end, current.end);
            } else {
                // 겹치지 않는 경우 새 범위 추가
                merged.push({
                    start: current.start,
                    end: current.end
                });
            }
        }
        
        return merged;
    };

    // selectBoxTimeInfo를 기반으로 점선 위치 계산하는 함수
    const calculateDashLinePosition = () => {
        if (!selectBoxTimeInfo || !waveStartDate || !waveEndDate) {            
            return null;
        }

        const selectedTime = moment(selectBoxTimeInfo);
        const startTime = moment(waveStartDate);
        const endTime = moment(waveEndDate);

        // 전체 타임라인 기간 (milliseconds)
        const totalDuration = endTime.diff(startTime);
        // 선택된 시간까지의 경과시간 (milliseconds)
        const timeFromStart = selectedTime.diff(startTime);
        // 백분율 계산 (0~100%)
        const leftPercent = (timeFromStart / totalDuration) * 100;
        
        // 0~100% 범위로 제한
        return Math.max(0, Math.min(100, leftPercent));
    };    

    // Filter Code 세팅
    const handleSetFilter = (filter) => {
        const savedFilter = localStorage.getItem('arrhythmiaCodeFilter');
        const loginId = localStorage.getItem('loginId');

        const parsedFilter = JSON.parse(savedFilter);
        parsedFilter[loginId] = filter;
        localStorage.setItem('arrhythmiaCodeFilter', JSON.stringify(parsedFilter));        

        setCodeFilter(filter);
        setIsOpenFilter(false);
    }

    // 알람 데이터 가져오기.
    const getArrhythmiaData = async () => {
        try{
            const res = await axios.get(`/trend/arrhythmias?serialNo=${selectBedInfo.serial}&startTime=${moment.utc(waveStartDate).format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment.utc(waveEndDate).format('YYYY-MM-DDTHH:mm:ss')}Z`);                               
            const processedEvents = processArrhythmiaData(res.data.events);            
            setArrhythmiaEvents(processedEvents);
            console.log('arrhythmiaEvents =>', processedEvents);
        }   
        catch(err){
            console.warn(err.message);
        }
    }

    //Search 기준 알람 데이터를 가져오는 로직
    const getIsSearchArrhythmiaData = async () => {
        try{
            const deviceHistory = selectBedInfo?.deviceHistory || [];
            const searchStart = moment(waveStartDate);
            const searchEnd = moment(waveEndDate);

            // 1. 환자별 입퇴원 기간 생성 (시리얼 기준)
            const periods = [];
            const sortedHistory = deviceHistory.slice().sort((a, b) => moment(a.createdAt) - moment(b.createdAt));
            let currentPeriod = null;
            sortedHistory.forEach(h => {
                if (h.action === 'ADMITTED') {
                    currentPeriod = {
                        serial: h.serial,
                        start: moment(h.createdAt),
                        end: null
                    };
                } else if (h.action === 'UNASSIGNED' && currentPeriod) {
                    currentPeriod.end = moment(h.createdAt);
                    periods.push(currentPeriod);
                    currentPeriod = null;
                }
            });
            if (currentPeriod && !currentPeriod.end) {
                currentPeriod.end = moment(); // 현재까지 입원
                periods.push(currentPeriod);
            }

            // 2. 검색 구간과 겹치는 기간만 추출
            const plans = [];
            periods.forEach(period => {
                const planStart = moment.max(searchStart, period.start);
                const planEnd = moment.min(searchEnd, period.end);
                if (planEnd.isAfter(planStart)) {
                    plans.push({
                        serial: period.serial,
                        start: planStart,
                        end: planEnd
                    });
                }
            });

            // 3. 각 구간별로 알람 데이터 가져오기
            let arrhythmias = [];
            for (const plan of plans) {
                const res = await axios.get(`/trend/arrhythmias?serialNo=${plan.serial}&startTime=${plan.start.utc().format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${plan.end.utc().format('YYYY-MM-DDTHH:mm:ss')}Z`);
                if (res.code != '200') throw res;
                const data = processArrhythmiaData(res.data.events);                
                arrhythmias = arrhythmias.concat(data);                
            }            

            setArrhythmiaEvents(arrhythmias);
        }
        catch(err){
            console.warn(err.message);
        }
    }

    // API 데이터를 시각화용 이벤트 바 데이터로 변환하는 메인 함수
    const processArrhythmiaData = (apiData) => {
        if (!apiData || !Array.isArray(apiData)) return [];

        const totalDuration = moment(waveEndDate).diff(moment(waveStartDate)); // 전체 타임라인 기간 (ms)        
        const events = [];
        const codeCountMap = {}; // eventName별 갯수 집계
        
        apiData.forEach((item) => {
            // eventName이 없으면 skip
            if (!item.eventName || !item.startTime || !item.endTime) return;

            // 코드 매핑
            const mappedName = dbCodeMappings[item.eventMessage.toLowerCase()] || dbCodeMappings[item.eventName.toLowerCase()] || item.eventName;

            // 집계
            codeCountMap[mappedName] = (codeCountMap[mappedName] || 0) + 1;

            // 시간 계산
            const start = moment(item.startTime);
            const end = moment(item.endTime);

            // 타임라인 범위 체크
            if (!start.isValid() || !end.isValid() || end.isBefore(start)) return;
            if (end.isBefore(moment(waveStartDate)) || start.isAfter(moment(waveEndDate))) return;

            // 실제 표시 구간 계산 (타임라인 내에서만)
            const clippedStart = moment.max(start, moment(waveStartDate));
            const clippedEnd = moment.min(end, moment(waveEndDate));

            const timeFromStart = clippedStart.diff(moment(waveStartDate));
            const leftPct = (timeFromStart / totalDuration) * 100;

            const eventDuration = clippedEnd.diff(clippedStart);
            const widthPct = (eventDuration / totalDuration) * 100;

            // 행 인덱스
            const rowIndex = codeFilter.indexOf(mappedName);            

            if (rowIndex >= 0 && leftPct <= 100 && widthPct > 0) {
                events.push({
                    rowIndex,
                    leftPct,
                    widthPct,
                    color: item.eventPriority == 2 ? '#FF002E' : (item.eventPriority == 1 || item.eventPriority == 0) ? '#FFF500' : '#FFFFFF',
                    eventName: item.eventName,
                    diagnosis: mappedName,
                    startTime: clippedStart.format('YYYY-MM-DD HH:mm:ss'),
                    endTime: clippedEnd.format('YYYY-MM-DD HH:mm:ss'),
                    patientId: item.patientId,
                    patientName: item.patientName,
                    zIndex : item.eventPriority == 2 ? 3 : (item.eventPriority == 1 || item.eventPriority == 0) ? 2 : 1,
                });
            }
        });
        
        const codeCountObj = codeFilter.reduce((acc, code) => {
            acc[code] = codeCountMap[code] || 0;
            return acc;
        }, {});        
        
        //console.log('codeCountObj : ',codeCountObj);

        setCodeCountArr(codeCountObj); // 필요시 useState로 관리

        return events;
    };

    useEffect(() => {
        const savedFilter = localStorage.getItem('arrhythmiaCodeFilter');
        const loginId = localStorage.getItem('loginId');

        //2. id 기준으로 배열 값 있는지 체크하고 가져오기
        if (savedFilter) {
            // 1️⃣ 전체 필터 데이터 파싱
            const parsedFilter = JSON.parse(savedFilter);

            // 2️⃣ 로그인 ID 기준으로 필터 배열 확인
            if (parsedFilter[loginId] && Array.isArray(parsedFilter[loginId])) {
                // ✅ 이미 데이터가 있으면 그대로 사용
                setCodeFilter(parsedFilter[loginId]);
            } else {
                // ❌ 해당 ID에 데이터가 없으면 default 저장
                parsedFilter[loginId] = filterDefaultCodeList;
                localStorage.setItem('arrhythmiaCodeFilter', JSON.stringify(parsedFilter));
                setCodeFilter(filterDefaultCodeList);
            }
        }
        else {
            // ❌ 전체 데이터 자체가 없을 때
            const newFilterData = { [loginId]: filterDefaultCodeList };
            localStorage.setItem('arrhythmiaCodeFilter', JSON.stringify(newFilterData));
            setCodeFilter(filterDefaultCodeList);
        }
    }, []);

    //StartTime이 변경 되면 다시 세팅
    useEffect(() => {
        if(moment(waveStartDate).isValid() && moment(waveEndDate).isValid() && codeFilter.length > 0){     
            if(isFromSearch){
                getIsSearchArrhythmiaData();
            }else{
                getArrhythmiaData();
            }
        }
    }, [waveStartDate,trendZoom,patientHistories,codeFilter])

    useEffect(() => {
        getPatientHistories(patientHistories);
    }, [selectBoxTimeInfo])

    // selectBoxTimeInfo가 변경될 때마다 점선 위치 업데이트
    useEffect(() => {
        const newLeftPercent = calculateDashLinePosition();
        setDashLineLeftPercent(newLeftPercent);        
    }, [selectBoxTimeInfo]);
    
    // timeSlots를 useMemo로 메모이제이션
    const timeSlots = useMemo(() => {
        if (!waveStartDate || !waveEndDate) return [];
        
        const start = moment(waveStartDate);
        const end = moment(waveEndDate);
        const slots = [];
        
        let current = start.clone();
        while (current.isBefore(end)) {
            slots.push(current.clone());
            current.add(5, 'minutes');
        }
        
        if (slots.length === 0 || !slots[slots.length - 1].isSame(end)) {
            slots.push(end.clone());
        }
        
        return slots;
    }, [waveStartDate,waveEndDate]);

    // Filter가 변경되면 arrhythmiaEvents 재정렬
    useEffect(() => {
        if (codeFilter.length > 0) {
            setArrhythmiaEvents(prevEvents => {
                if (!Array.isArray(prevEvents)) return [];
                const reordered = prevEvents
                    .map(ev => ({
                        ...ev,
                        rowIndex: codeFilter.indexOf(ev.diagnosis)
                    }))                
                    .sort((a, b) => a.rowIndex - b.rowIndex);
                return reordered;
            });
        }
    }, [codeFilter]);

    return (
        <div className="relative w-full h-full bg-[#2F2F2F] px-[20px]">
            <div className="flex justify-between items-center h-[40px]">
                <h2 className="text-white text-center font-medium text-lg leading-[110%] font-pretendard">
                    {t("trend.arrhythmia")}
                </h2>
                <div className="flex items-center justify-center cursor-pointer gap-[8px]">
                    <div className="flex items-center justify-center w-[140px] h-[28px] cursor-pointer text-white rounded-[6px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] p-[7px_8px]" onClick={() => setIsOpenFilter(true)}>
                        <span className="text-white text-center font-light text-base leading-[110%] font-pretendard">{t("trend.selectItems")}</span>
                    </div>
                    {isTrendFull && (
                        <div
                            className="flex items-center justify-center cursor-pointer text-white rounded-[4px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] p-[4px]"
                            onClick={onClose}
                        >
                            <IconArrowDown className="w-[18px] h-[18px] text-white" />
                        </div>
                    )}
                </div>
            </div>
            <div className="w-full relative border border-[#5E5E5E] rounded-[8px] overflow-hidden">
                <div className="w-full flex flex-col">                         
                    <div
                        className="relative scrollbar"
                        style={{                            
                            maxHeight: isTrendFull ? '358px' : '145px',
                            overflowY: 'auto',
                            overflowX: 'hidden',                            
                        }}
                    >
                        <div className="flex">
                            <div className="w-[155px] bg-[#343434] select-none">
                                <div className="sticky top-0 z-10 h-[12px] bg-[#343434] border-b border-[#444]"></div>
                                {/* Alarm Code / Alarm 갯수 */}
                                {codeFilter.map((label, idx) => (
                                    <div key={label} className={`flex items-center px-2 h-[16px] border-b border-[rgba(255,255,255,0.02)]`}>
                                        <div className={`w-[127px] text-[#FFF] font-light text-[12px] leading-[110%]`}>{label}</div>
                                        <div className={`w-[28px] text-right text-[#FFF] font-light text-[12px] leading-[110%] ml-1`}>{codeCountArr[label]}</div>
                                    </div>
                                ))}
                            </div>

                            {/* 오른쪽 이벤트 영역 */}
                            <div className="relative w-full flex-1 bg-[#1F1F1F]">        
                                {/* Select 세팅 영역 - 동적 위치로 변경 */}
                                {
                                    dashLineLeftPercent !== null && (
                                        <div 
                                            className="absolute top-0 w-[1px] border-l-[1px] border-dashed border-white z-[1]" 
                                            style={{ 
                                                left: `${dashLineLeftPercent}%`,
                                                height: `${12 + (codeFilter.length * 16)}px` 
                                            }}
                                        ></div>
                                    )
                                }

                                {/* 오른쪽 헤더 - sticky로 고정 */}
                                <div className="sticky top-0 z-10 w-full h-[12px] bg-[#1F1F1F] border-b border-[#444] ">
                                    <div className="h-full relative px-3">                                        
                                        {timeSlots.map((timeSlot, index) => {
                                            let leftPercent;
                                            
                                            if (index === 0) {
                                                leftPercent = 1.5; // 맨 앞 시간
                                            } else if (index === timeSlots.length - 1) {
                                                leftPercent = 98.5; // 맨 뒤 시간
                                            } else {
                                                // 중간 시간들은 5%~95% 구간에서 균등 분배
                                                const middleSlots = timeSlots.length - 2; // 중간 슬롯 개수
                                                const gapSize = 90 / (middleSlots + 1); // 90% 구간을 균등 분할
                                                leftPercent = 5 + (index * gapSize);
                                            }
                                            
                                            return (
                                                <div 
                                                    key={index} 
                                                    className="absolute text-[#DEDEDE] text-[12px] font-light leading-[110%]"
                                                    style={{                                                         
                                                        left: `${leftPercent}%`,
                                                        top: '50%',
                                                        transform: 'translate(-50%, -50%)'
                                                    }}
                                                >
                                                    {timeSlot.format('HH:mm:ss')}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                                
                                {/* 행 구분선들 */}
                                <div className="absolute left-0 right-0 top-[12px]">
                                    {codeFilter.map((_, i) => (
                                        <div key={i} className={`h-[16px] ${i < codeFilter.length - 1 ? "border-b border-[#444]": ""}`}/>
                                    ))}
                                </div>
                                
                                {/* 시간 구분선들 (세로선) - 시간과 정확히 동일한 위치 */}
                                {timeSlots.length > 0 && (
                                    <div className="absolute top-[12px] left-0 right-0" style={{ height: `${codeFilter.length * 16}px` }}>
                                        <div className="relative h-full">
                                            {timeSlots.map((timeSlot, index) => {
                                                let leftPercent;
                                                
                                                if (index === 0) {
                                                    leftPercent = 0; // 맨 앞 세로선
                                                } else if (index === timeSlots.length - 1) {
                                                    leftPercent = 100; // 맨 뒤 세로선
                                                } else {
                                                    // 중간 세로선들은 5%~95% 구간에서 균등 분배
                                                    const middleSlots = timeSlots.length - 2; // 중간 슬롯 개수
                                                    const gapSize = 90 / (middleSlots + 1); // 90% 구간을 균등 분할
                                                    leftPercent = 5 + (index * gapSize);
                                                }
                                                
                                                return (
                                                    <div
                                                        key={index}
                                                        className="absolute border-l border-[#666] opacity-80"
                                                        style={{                                                            
                                                            left: `${leftPercent}%`,
                                                            top: '0',
                                                            height: '100%',
                                                            transform: 'translateX(-0.5px)'
                                                        }}
                                                    />
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}

                                {/* 선택한 Arrhythmia 데이터 표기 */}
                                {arrhythmiaEvents.map((ev, index) => {
                                    const topPx = (ev.rowIndex * 16) + (16 - 12) / 2; // 각 행의 중앙에 배치
                                    return (
                                        <div
                                            key={`${ev.eventName}-${moment(ev.startTime).format('YYYY-MM-DDTHH:mm:ss')}-${index}`}
                                            className={`absolute rounded-sm shadow-md h-[12px] cursor-pointer hover:opacity-80 transition-opacity`}
                                            style={{                                                
                                                top: `${12 + topPx}px`,
                                                left: `${ev.leftPct}%`,
                                                width: `${ev.widthPct}%`,
                                                backgroundColor: ev.color,
                                            }}
                                            title={`${ev.diagnosis}- (${ev.startTime} ~ ${ev.endTime})`} // 상세정보 툴팁
                                        />
                                    );
                                })}                                                                

                                {stripedBackground && stripedBackground.length > 0 && 
                                    stripedBackground.map((striped, idx) => (
                                        <React.Fragment key={`striped-area-${idx}`}>
                                            {/* 빗금 영역 */}
                                            <div 
                                                className="absolute top-[12px] h-[calc(100%-12px)] bg-black bg-opacity-20" 
                                                style={{
                                                    zIndex: 1,
                                                    left: `${striped.start}%`,
                                                    width: `${striped.end - striped.start}%`, 
                                                    background: 'repeating-linear-gradient(135deg, transparent, transparent 2px, #6C6C6C80 2px, #6C6C6C80 4px)' 
                                                }}
                                            />

                                            {/* 뒤쪽 빗금 시작점에 선 추가 */}
                                            {
                                                striped.start > 0 && striped.start < 100 && (
                                                    <div 
                                                        key={`patient-line-${idx}`}
                                                        className="absolute top-[12px] w-[1px] h-[calc(100%-12px)] bg-white z-[2]"
                                                        style={{ left: `${striped.start}%` }}
                                                    >
                                                        <div className="absolute top-0 left-[-10px] w-0 h-0 border-b-[10px] border-b-transparent border-r-[10px] border-r-white"></div>
                                                        <div className="absolute bottom-0 left-[-10px] w-0 h-0 border-t-[10px] border-t-transparent border-r-[10px] border-r-white"></div>
                                                    </div>
                                                )
                                            }
                                        </React.Fragment>
                                    ))
                                }

                                {/* 환자 라인들 별도로 표시 */}
                                {Array.isArray(patientLines) && patientLines.map((linePercent, lineIdx) => (
                                    <div 
                                        key={`patient-line-${lineIdx}`}
                                        className="absolute top-[12px] w-[1px] h-[calc(100%-12px)] bg-white z-[2]"
                                        style={{ left: `${linePercent}%` }}
                                    >
                                        <div className="absolute top-0 left-[-10px] w-0 h-0 border-b-[10px] border-b-transparent border-r-[10px] border-r-white"></div>
                                        <div className="absolute bottom-0 left-[-10px] w-0 h-0 border-t-[10px] border-t-transparent border-r-[10px] border-r-white"></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>            

            { isOpenFilter && 
                <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-[999]">
                    <Filter codeFilter={codeFilter} defaultCode={filterDefaultCodeList} handleSetFilter={handleSetFilter} onClose={() => setIsOpenFilter(false)} />
                </div>
            }
            
        </div>
    );
};

export default Arrhythmia;
